module.exports = __webpack_public_path__ + "img/scene-3.b2d1a73.png";